<!--ReleaseInfoComponent-->
<template>
  <div class="p-20 relative flex flex-col gap-20 rounded-3xl bg-neutral-variant-2">
    <i class="absolute top-32 bottom-32 left-[3.1rem] w-[.2rem] bg-border"></i>
    <slot></slot>
  </div>
</template>
<script setup lang="ts"></script>
